/* eslint-disable no-case-declarations */
/* eslint-disable eqeqeq */
export const types = {
  POST: 'CREATE_VIDEO_CONTENT',
  PUT: 'UPDATE_VIDEO_CONTENT',
  DELETE: 'DELETE_VIDEO_CONTENT',
  RESET: 'RESET_VIDEO_CONTENT',
};

export const videoContentReducer = (state = [], action) => {
  switch (action.type) {
    case types.POST:
      return [
        ...state,
        action.payload,
      ];
    case types.PUT:
      return state.map((child) => (child.id == action.index ? action.payload : child));
    case types.DELETE:
      const newValues = [...state];
      const index = newValues.findIndex((x) => x.id == action.index);
      newValues.splice(index, 1);
      return newValues;
    case types.RESET:
      return [];
    default:
      return state;
  }
};
